/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect,useState,useContext,useRef } from "react"
import { motion } from 'framer-motion'
import TopHeader from "../../../components/TopHeader"
import { Link } from "react-router-dom"
import moment from "moment"
// import { dataService } from "../../services/data.services"
import { useParams,useLocation,useNavigate,useSearchParams } from "react-router-dom"
import { useSelector,useDispatch} from 'react-redux'
import CustomOverLay from "../../../components/CustomOverLay"
import GlobalContext from "../../../components/Context/GloablContext"
import AnimatedButton from "../../../components/Animation/AnimatedButton"
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick"
import AnimatedList from "../../../components/Animation/AnimatedList"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import formatMobileNumber from "../../../CommonMethods/FormatMobileNumber"
import { useGetMonitorQuery, useLazyGetPatientAssociatedMonitorQuery } from "../../../features/manageMonitorSlice"
import OrganizationList from "./Components"
import { convertEpochToDateFormat } from "../../../CommonMethods/DateConversion"
import ViewMonitorAssociatedPatientListing from "./Components/ViewMonitorAssociatedPatients"
import { handleEditMessageSent } from "../../../redux/systemConfigSlice"
import HelpGuideModal from '../../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'
import OtpPreferenceList from "../../../components/OtpPreferenceList/OtpPreferenceList"
import { resetProviderSearch } from "../../../redux/providerSearchSlice"

export default function ViewMonitorUsr({isOrganization,monitor_id}){
    const [searchParams,setSearchParams] = useSearchParams()
    const navigate=useNavigate()
    const {isSideBar,editSocket,sendMessageToStartEditing,setToastErrorMessage,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const location=useLocation();
    const auth=useSelector(state=>state.auth)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const viewId=useSelector(state=>state?.systemConfigData?.viewToUser)
    const [isChangeStatusOPen,setIsChangeStatusOpen]=useState(false)
    const outSideClick = useRef();
    const dispatch = useDispatch()
    const {id}=useParams()
    const viewData=useGetMonitorQuery(isOrganization===undefined?id:monitor_id,{refetchOnMountOrArgChange: true})
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)

    const ref=useRef()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
     useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-view-monitor-users');
        } else {
            setQueryParamsadmin('type=admin-view-monitor-users');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })
    
    const date=convertEpochToDateFormat(viewData?.data?.created_at,dateformat)

    const handleGobackFn = () =>{
        let params = Object.fromEntries(searchParams);
        params['view']!==null && delete params['view']
        setSearchParams({ ...params})
    }

    const handleNavigationToEditPage = () => {
        if(!messageSent){
            sendMessageToStartEditing(viewData.data.user_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
         
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-monitor-user/add-monitor-user/${id}`,{state:[location.state,true,id]})
                    dispatch(resetProviderSearch()),
                    setIsAdvancedSearchOpen(false) 
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this monitor`)
                    }
                    
                }
            }    
        }
}

    const [patientTrigger, patientResult] = useLazyGetPatientAssociatedMonitorQuery();
const [patientQueryParams, setPatientQueryParams] = useState('');

useEffect(() => {
    if (viewData.data !== undefined && viewData.data.user_id) {
        const queryParams = new URLSearchParams();
        queryParams.set('page_number', '1');
        queryParams.set('limit', '15');
        setPatientQueryParams(`${viewData.data.user_id}?${queryParams.toString()}`);
    }
}, [viewData]);

useEffect(() => {
    if (patientQueryParams) {
        patientTrigger(patientQueryParams);
    }
}, [patientQueryParams, patientTrigger]);


    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                {<TopHeader title={isOrganization===undefined?"Manage Monitor User":"Manage Organizations"}/>}
                {viewData?.isFetching&&viewData?.status!=="fulfilled"?<CustomOverLay Active text="Loading Monitor User Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>

                    <div className='bg-white rounded-lg py-[14px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className="px-[30px]">
                                    <div className='flex items-center mb-[32px]'>
                                        {isOrganization===undefined?<>
                                            <Link to="/manage-monitor-user" state={Array.isArray(location.state)?'':location.state}>
                                                <h1 className="text-sm font-normal text-[#52555D]">List of Monitor Users</h1>
                                            </Link>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <h1 className="text-sm font-normal text-[#008586]">View Monitor User</h1>
                                            {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
                                        </>:<>
                                            <Link to="/manage-organizations">
                                                <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                                            </Link>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        
                                            {viewId!==""&&<>
                                                <Link to={`/manage-organizations/${viewId}`}>
                                                    <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                                </Link>
                                                <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            </>} 
                                            <button onClick={handleGobackFn}>
                                                <h1 className="text-sm font-normal text-[#52555D]">List of Monitor Users</h1>
                                            </button>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <h1 className="text-sm font-normal text-[#008586]">View Monitor User</h1>
                                            {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
                                        </>}
                                    </div>
                                    <div className="flex items-center pb-3 pr-9">
                                        {isOrganization===undefined?<Link to={'/manage-monitor-user'} state={Array.isArray(location.state)?'':location.state} className='flex items-center min-w-max z-10'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </Link>:<button onClick={handleGobackFn} className='flex items-center min-w-max z-10'> 
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </button>}
                                        <h1 className='text-xl font-normal text-[#000000] text-center w-full -ml-[146px]'>
                                            View Monitor
                                        </h1>
                                        {isOrganization===undefined?
                                            <div className="xl:hidden block">
                                                <button type="button" 
                                                    onClick={() => { handleNavigationToEditPage()}}
                                                    id="edit" className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                                    <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                </button>
                                            </div>
                                        :''
                                        }
                                    </div>
                                </div>
                                <div className="pl-[30px] pr-4">
                                    <div className="flex justify-between items-center pl-[30px] pr-11">
                                        <div className="flex items-center">
                                            <p className="text-xl font-semibold text-[#000000] break-all">{viewData?.data?.first_name} {viewData?.data?.last_name}</p>
                                            <p className="text-sm font-normal text-[#000000] px-5">{viewData?.data?.user_id}</p>
                                            {viewData?.data?.status=='inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : 
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                                }
                                        </div>
                                        {isOrganization===undefined?
                                            <div className="flex items-center">
                                                <button type='button'
                                                    onClick={()=>{navigate('/manage-monitor-user/activity_history',{state:[viewData?.data?.user_name,true,id]}),
                                                        dispatch(resetProviderSearch()),
                                                        setIsAdvancedSearchOpen(false) 
                                                    }}
                                                    id="view_activity_log"
                                                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] `} style={{'width':'max-content'}}>
                                                    <span>View Activity Log</span> 
                                                </button>
                                                <div className="xl:block hidden">
                                                    <button type="button" 
                                                        onClick={() => { handleNavigationToEditPage()}}                                                    
                                                        id="edit" className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                                        <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                                        <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                    </button>
                                                </div>
                                                
                                            </div>:''
                                        }
                                    </div>
                                    <div className="h-customh9 overflow-auto scrollbar_purple pr-2.5 mt-4">
                                        <div className="w-full px-6">
                                            <div className="bg-[#E7EAF4] rounded-lg p-6">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Username</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.user_name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.email_address===""?"-":viewData?.data?.email_address}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.mobile_number===""?"-":viewData?.data?.mobile_country_code} {formatMobileNumber(viewData?.data?.mobile_number)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.main_country_code} {formatMobileNumber(viewData?.data?.main_number)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Monitor Permission</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewData?.data?.monitor_permission==='monitor'?'Monitor':'View'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {date}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Block SMS Alert</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words -ml-1">
                                                                <span className={`inline-flex items-center justify-start bg-[#E7EAF4] text-[#000000] pl-[6px] pr-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                                    {(viewData?.data?.block_sms ?? viewData?.data?.userDetails?.block_sms) === true ? "ON" : "OFF"}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Block Email Alert</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words -ml-1">
                                                                <span className={`inline-flex items-center justify-start bg-[#E7EAF4] text-[#000000] pl-[6px] pr-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                                    {(viewData?.data?.block_email ?? viewData?.data?.userDetails?.block_email) === true ? "ON" : "OFF"}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-full px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {((viewData?.data?.address))?viewData?.data?.address:'-'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <OtpPreferenceList
                                                username={viewData?.data?.user_name}
                                            />
                                            <ViewMonitorAssociatedPatientListing
                                                // providerInfo={providerInfo}
                                                monitor_id={viewData?.data?.user_id}
                                                trigger={patientTrigger}
                                                result={patientResult}
                                                setPatientQueryParams={setPatientQueryParams}
                                                patientQueryParams={patientQueryParams}
                                            />

                                            <OrganizationList 
                                                id={isOrganization===undefined?id:monitor_id}
                                                user_id={viewData?.data?.user_id}
                                                
                                            />
                                            {(helpGuideModel && helpguidestatus==="fulfilled") &&
                                            <HelpGuideModal
                                                setHelpGuideModel={setHelpGuideModel}
                                                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
            </div>
        </>
    )
}